export default "__VITE_ASSET__T6wMbyl2__"